import { TimeoutType } from 'client/src/utils/utils';
import {actionCreatorFactory} from 'typescript-fsa';
import { Tours, UILocation } from '../reducers/app-reducers';
import { ITSTourSteps } from '../../components/tour-steps';
import { TeacherClassroom } from '../../types/classroom';
export interface DelayedRedirect {
  location: UILocation;
  delay?: number;
}

const actionCreator = actionCreatorFactory('app');

export const appStart = actionCreator('APP_START');

export const uiRedirect = actionCreator<UILocation>('UI_REDIRECT');

export const delayedRedirect = actionCreator<DelayedRedirect>(
  'DELAYED_REDIRECT'
);

export const setLocation = actionCreator<UILocation>('SET_LOCATION');
export const setRedirectTimeout = actionCreator<TimeoutType>(
  'SET_REDIRECT_TIMEOUT'
);

export const setCurrentClassroomToken = actionCreator<string>(
  'SET_CURRENT_CLASSROOM_TOKEN'
);

export const setCurrentStudentClassroomToken = actionCreator<string>(
  'SET_CURRENT_STUDENT_CLASSROOM_TOKEN'
);

export const setURLClassroomToken = actionCreator<string | undefined>(
  'SET_URL_CLASSROOM_TOKEN'
);

export const setURLModule = actionCreator<string>('SET_URL_MODULE');

export interface LTIVars {
  ltijsUrl: string | null;
  ltiToken: string | null;
};
/**
 * Action to set this client run in LTI environment mode.
 */
export const setLTIEnv = actionCreator<LTIVars>('SET_LTI_Env');
export const setLTIModule = actionCreator<string>('SET_LTI_MODULE');

export const setClassroomMode = actionCreator<boolean>('SET_CLASSROOM_MODE');

export const setToursShown = actionCreator<Tours>('SET_TOURS_SHOWN');

export const setOpenTour = actionCreator<boolean>('SET_OPEN_TOUR');

export const setTourSteps = actionCreator<ITSTourSteps>('SET_TOUR_STEPS');

/**
 * List containing formatted unix timestamps (in ms) for start and end time for a course
 */
export const setClassStartAndEndDates = actionCreator<number[]>('SET_CLASS_START_END_DATE');

/**
 * Boolean of whether student clients should send grade progress.
 * In context of Canvas they will automatically populate the teacher grade book if autograde is true.
 */
export const setClassAutoGrade = actionCreator<boolean>('SET_CLASS_AUTO_GRADE');

/**
 * Boolean for whether to enable/disable the sending of logging data for teacher dashboard.
 * If enabled, the client app with send extra network requests with telemtry data if on the teacher
 * dashboard.
 */
export const setDashboardTelemetry = actionCreator<boolean>('SET_DASHBOARD_LOGGING');

/**
 * Triggered when teacher want to increment the version tag for module related data, used to reset progress and
 * stats for that module.
 * Pass in the name of the module to 'reset' progress of
 * Version (middleware automatically fills this in with appropriate value if undefined on dispatch)
 */
export const resetProgressForModule = actionCreator<{module: string, version: string | undefined}>('RESET_MODULE_PROGRESS');

/**
 * Once the classroom token is known, we want to update the redux store with classroom specific settings:
 * start + end dates
 * auto grade setting
 */
export const updateClassSettingsFromDb = actionCreator<Partial<TeacherClassroom>>('UPDATE_CLASS_FROM_DB');